const ATTRIBUTION_KEY = 'spotsurferAttribution';
const WINDOW_DAYS = 90;
const CLICK_IDS = ['fbclid', 'gclid', 'li_fat_id', 'ttclid', 'msclkid'];
const UTM_FIELDS = ['source', 'medium', 'campaign', 'content', 'term'];

const clip = (value, max) => (value || '').trim().slice(0, max);

const externalReferrer = () => {
  try {
    const referrer = new URL(document.referrer);
    return referrer.host === window.location.host ? '' : clip(referrer.origin + referrer.pathname, 500);
  } catch {
    return '';
  }
};

export const captureAttribution = () => {
  const query = new URLSearchParams(window.location.search);
  const clickIdType = CLICK_IDS.find(name => query.get(name));
  if (!query.get('utm_source') && !clickIdType) return;

  const touch = {
    click_id_type: clickIdType || '',
    click_id: clickIdType ? clip(query.get(clickIdType), 500) : '',
    referrer: externalReferrer(),
    landing_page: clip(window.location.pathname, 500),
    landed_at: new Date().toISOString(),
  };
  UTM_FIELDS.forEach(field => {
    touch[field] = clip(query.get(`utm_${field}`), 255);
  });
  touch.utm_id = clip(query.get('utm_id'), 255);

  try {
    localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(touch));
  } catch {
    return;
  }
};

export const currentAttribution = () => {
  try {
    const touch = JSON.parse(localStorage.getItem(ATTRIBUTION_KEY));
    const age = Date.now() - new Date(touch?.landed_at).getTime();
    if (!(age >= 0 && age <= WINDOW_DAYS * 24 * 60 * 60 * 1000)) {
      localStorage.removeItem(ATTRIBUTION_KEY);
      return null;
    }
    return touch;
  } catch {
    return null;
  }
};
